import { infrastructureArchitectureStatePreferenceKey } from "@/store/infrastructure-architecture/utils/constants/constants";
import { InfrastructureArchitectureLocalStorageData } from "@/store/infrastructure-architecture/utils/types/types";

export const selectInfrastructureArchitectureStateInLocalStorage = () => {
  const item = localStorage.getItem(
    infrastructureArchitectureStatePreferenceKey,
  );
  let parsed: InfrastructureArchitectureLocalStorageData = {};

  try {
    parsed = JSON.parse(item || "{}");
  } catch (e) {
    return {};
  }

  return parsed;
};
